import {Injectable} from "@angular/core";
import {RestClientService} from "../../../../projects/shared/src/lib/rest-client.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({providedIn: "root"})
export class InspectionService {

  constructor(private restClient: RestClientService) {
  }

  public getInspection(skipGlobalLoading = false): Observable<any> {
    return this.restClient.get('/inspections', undefined, {skipGlobalLoading})
      .pipe(map(response => {
        if (response.success) {
          return response.data;
        }
      }))
  }
}
